export default {
  props: {
    linkTargets: {
      type: String,
      default: '_self'
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/LinkTargets.js